'use strict';

// var Backbone = require('backbone');
const _ = require('lodash');
const Model = require('./model.js');
const object = require('../utils/object.js');

const Widget = Model.extend({
    constructor: function (curation, definition, options) {
        const me = this;

        me.curation = curation;
        _.extend(me, _.omit(definition, 'props'));

        options = options || {};
        me.cid = _.uniqueId(me.cidPrefix);

        me.curationProps = curation.attributes;
        me.configurationProps = _.create(me.curationProps, definition.props);

        let queryProps = {};
        // Query props clobber configuration if this is a widget focus view
        if (!curation.widgetId && (me.curationProps.instanceId || me.curationProps.widgetId)) {
            queryProps = object.ownProperties(curation.queryProps);
        } else { // If this is a curation view the wProps hash allows for overriding widget specific properties
            queryProps = _.get(me.curationProps, ['wProps', definition.instanceId], {});
        }

        me.queryProps = _.create(me.configurationProps, queryProps);
        me.attributes = _.create(me.queryProps, {
            id: definition.instanceId || _.uniqueId('w')
        });

        me.id = me.get(me.idAttribute);
        if (options.collection) { me.collection = options.collection; }
        me.changed = {};
        me.initialize.apply(me, arguments);

        me.configuration = me.buildConfiguration();
    },

    /*
     * Save the widget configuration model
     * On save the widget model is updated with changed configuration
     * attributes
     */
    save: function (props, options) {
        const me = this;

        options = _.extend({
            success: function () {
                me.resetPropHash('configurationProps', me.configuration.get('props'));
            }
        }, options);

        const attrs = me.toJSON();
        attrs.props = _.extend({}, attrs.props, props);

        return Model.prototype.save.call(me, attrs, options);
    },

    toJSON: function () {
        const me = this;

        return {
            instanceId: me.instanceId,
            widgetId: me.widgetId,
            props: _.omit(me.getProps(), 'instanceId', 'widgetId')
        };
    },

    /*
     * Returns true if this widget is the focus of a details page
     */
    isFocus: function () {
        const me = this;

        // NOTE this intentionally pulls from Props and not me.instanceId
        // This allows us to check if we are displaying this widget as a detail
        const instanceId = me.getProp('instanceId');
        const widgetId = me.getProp('widgetId');
        return (!_.isUndefined(instanceId) && instanceId === me.instanceId) ||
            (!_.isUndefined(widgetId) && widgetId === me.widgetId);
    },

    getConfigurationForWidget: function () {
        const me = this;
        return me.configuration;
    },

    getBasePath: function (props) {
        const me = this;

        return me.curation.getBasePath(_.extend(props || {}, {
            instanceId: me.instanceId
        }));
    },

    getBaseUrlObject: function (props) {
        const me = this;

        return me.curation.getBaseUrlObject(_.extend(props || {}, {
            instanceId: me.instanceId
        }));
    },

    getPath: function (overrides) {
        const me = this;
        const attrs = {};

        if (me.instanceId) {
            _.extend(attrs, {
                instanceId: me.instanceId
            }, object.ownProperties(me.queryProps));
        } else {
            // TODO omit curation props?
            _.extend(attrs, {
                widgetId: me.widgetId
            }, me.getProps());
        }

        return me.curation.getPath(_.extend(attrs, overrides));
    },

    filter: false,

    isEqual: function (definition) {
        const me = this;

        if (me.instanceId === definition.instanceId) {
            return true;
        }

        const wDef = me.toJSON();

        return wDef.widgetId === definition.widgetId &&
            _.isEqual(wDef.props, definition.props);
    },

    getView: function () {
        const me = this;
        return me.view;
    },

    getQueryParams: function () {
        const me = this;
        return me.curation.getQueryParams();
    }
});

module.exports = Widget;
